import React, { useState, useRef, useEffect } from 'react';
import { AlertCircle, Globe } from 'lucide-react';
import 'flag-icons/css/flag-icons.min.css';
import { COUNTRIES } from '../services/countries/countryData';
import './CountryPhoneSelector.css';

export function CountryPhoneSelector({ 
  selectedCountry, 
  onCountryChange, 
  phoneValue, 
  onPhoneChange,
  phoneError,
  setPhoneError,
  placeholder = "Número de teléfono",
  requeired = true,
  label = "Teléfono",
  disabled = false
}) {
  const selectedCountryData = COUNTRIES.find(c => c.code === selectedCountry);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    onPhoneChange(value);
    
    if (selectedCountryData) {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length > 0 && digitsOnly.length !== selectedCountryData.phoneDigits) {
        setPhoneError(`${selectedCountryData.phoneDigits} dígitos requeridos`);
      } else {
        setPhoneError('');
      }
    }
  };

  const handleSelectCountry = (countryCode) => {
    onCountryChange(countryCode);
    setPhoneError('');
    setIsDropdownOpen(false);
  };

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getFlagCode = (code) => {
    // Convertir códigos a lowercase para flag-icons
    return code.toLowerCase();
  };

  return (
    <div className="country-phone-container">
      <label className="country-phone-label">
        {label}
        {requeired && (
          <span className="required-asterisk">*</span>
        )}
      </label>
      
      <div className="country-phone-wrapper">
        {/* Country Selector */}
        <div className="country-selector-box" ref={dropdownRef}>
          <button
            className="country-select-btn"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            type="button"
            disabled={disabled}
            title={selectedCountryData ? `${selectedCountryData.name} (${selectedCountryData.phoneCode})` : 'Seleccionar país'}
          >
            {selectedCountryData ? (
              <span className={`fi fi-${getFlagCode(selectedCountryData.code)}`}></span>
            ) : (
              <Globe size={20} color="#94a3b8" />
            )}
          </button>

          {isDropdownOpen && (
            <div className="country-dropdown-menu">
              {COUNTRIES.map(country => (
                <button
                  key={`${country.code}-${country.phoneDigits}`}
                  type="button"
                  className={`country-option ${selectedCountry === country.code ? 'selected' : ''}`}
                  onClick={() => handleSelectCountry(country.code)}
                >
                  <span className={`fi fi-${getFlagCode(country.code)}`}></span>
                  <div className="option-info">
                    <span className="option-name">{country.name}</span>
                    <span className="option-phone">{country.phoneCode}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Phone Input */}
        <div className="phone-input-wrapper">
          <input
            type="tel"
            className={`phone-input ${phoneError ? 'error' : ''}`}
            placeholder={placeholder}
            value={phoneValue}
            onChange={handlePhoneChange}
            inputMode="tel"
            disabled={disabled}
          />
          
          {selectedCountryData && !phoneError && (
            <div className="phone-helper">
              <span className={`fi fi-${getFlagCode(selectedCountryData.code)}`}></span>
              <span className="phone-helper-text">{selectedCountryData.phoneCode} • {selectedCountryData.phoneDigits} dígitos</span>
            </div>
          )}
          
          {phoneError && (
            <div className="phone-error-message">
              <AlertCircle size={12} className="error-icon" />
              <span>{phoneError}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
